import { Controller } from "@hotwired/stimulus"

// Signals > Finance > Runway: the What if form's scenario picker. Picking a
// ready-made scenario sets every lever to its values (the months stay) and
// submits; editing a lever by hand makes the picker read "Custom".
export default class extends Controller {
    static targets = ["pick"]
    static values = { presets: Object }

    pick() {
        const levers = this.presetsValue[this.pickTarget.value]
        if (!levers) return

        Object.entries(levers).forEach(([name, value]) => {
            const field = this.element.elements.namedItem(name)
            if (field) field.value = (value === 0 ? "" : value)
        })
        this.element.requestSubmit()
    }

    edited(event) {
        if (event.target !== this.pickTarget) this.pickTarget.value = "custom"
    }
}
